import { render, staticRenderFns } from "./orders-modal.vue?vue&type=template&id=03d91654"
import script from "./orders-modal.vue?vue&type=script&lang=js"
export * from "./orders-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports